import { ConfigProvider } from 'antd'
import { useEffect, useRef } from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { ThemeProvider } from 'styled-components'
import App from './App'
import NotificationProvider from './components/provider'
import { NotificationHandler } from './components/provider/NotificationProvider'
import { useTheme } from './hooks'
import './i18n/i18n'
import './index.css'
import reportWebVitals from './reportWebVitals'
import { notificationService } from './services'
import store from './store'
import './table.css'
import './tree.css'
import './select.css'

const ThemeConfigProvider = ({ children }: { children: React.ReactNode }) => {
  const { themeConfiguration } = useTheme() // cant call this in Root Component
  const notificationRef = useRef<NotificationHandler>(null)
  useEffect(() => {
    notificationService.setNotificationRef(notificationRef.current)
  }, [])

  return (
    <ConfigProvider theme={themeConfiguration}>
      <ThemeProvider theme={themeConfiguration}>
        <NotificationProvider ref={notificationRef}>
          {children}
        </NotificationProvider>
      </ThemeProvider>
    </ConfigProvider>
  )
}

const RootComponent = () => {
  return (
    <BrowserRouter>
      <Provider store={store}>
        <ThemeConfigProvider>
          <App />
        </ThemeConfigProvider>
      </Provider>
    </BrowserRouter>
  )
}

const rootElement = document.getElementById('root') as HTMLElement

if (rootElement) {
  const root = ReactDOM.createRoot(rootElement)
  root.render(<RootComponent />)
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
